import { split, join } from 'lodash'

export const replaceSpacesWithDashes = (value) => 
 join(split(value, ' '), '-')